if (!customElements.get('sr2-video')) {
  class Sr2Video extends HTMLElement {
    constructor() {
      super();
      this.inView = false;
      this.bound = false;
      this.playPending = false;
      this.generation = 0;
      this.reconcile = this.reconcile.bind(this);
    }

    connectedCallback() {
      if (this.bound) return;

      this.video = this.querySelector('video');
      if (!this.video) return;

      this.bound = true;
      this.generation += 1;
      this.inView = false;
      this.playPending = false;
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.listeners = new AbortController();
      const listenerOptions = { signal: this.listeners.signal };

      this.video.muted = true;
      this.video.defaultMuted = true;
      this.video.playsInline = true;
      this.video.loop = true;
      this.video.autoplay = false;
      this.video.removeAttribute('autoplay');
      this.video.pause();
      this.video.controls = false;
      this.video.addEventListener('canplay', this.reconcile, listenerOptions);
      document.addEventListener('visibilitychange', this.reconcile, listenerOptions);
      this.motionPreference.addEventListener('change', this.reconcile, listenerOptions);

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            const entry = entries.find((item) => item.target === this);
            if (!entry) return;
            const nextInView = entry.isIntersecting && entry.intersectionRatio >= 0.2;
            if (nextInView === this.inView) return;
            this.inView = nextInView;
            this.reconcile();
          },
          { threshold: [0, 0.2] }
        );
        this.observer.observe(this);
      } else {
        this.inView = true;
        this.reconcile();
      }
    }

    disconnectedCallback() {
      this.bound = false;
      this.generation += 1;
      this.observer?.disconnect();
      this.listeners?.abort();
      this.video?.pause();
      this.inView = false;
      this.playPending = false;
      this.video = null;
      this.observer = null;
      this.listeners = null;
      this.motionPreference = null;
    }

    shouldPlay() {
      return (
        this.bound &&
        this.isConnected &&
        this.inView &&
        !document.hidden &&
        !this.motionPreference.matches
      );
    }

    reconcile() {
      if (!this.bound || !this.video) return;
      if (this.shouldPlay()) {
        this.requestPlay();
      } else {
        this.video.pause();
      }
    }

    async requestPlay() {
      if (!this.video || !this.video.paused || this.playPending) return;

      const video = this.video;
      const generation = this.generation;
      this.playPending = true;
      video.muted = true;

      try {
        await video.play();
      } catch {
      } finally {
        if (generation !== this.generation || video !== this.video) {
          if (video !== this.video || !this.bound) video.pause();
          return;
        }

        this.playPending = false;
        if (!this.shouldPlay()) video.pause();
      }
    }

  }

  customElements.define('sr2-video', Sr2Video);
}
